import { NgModule } from '@angular/core';
import { PortalFormErrorComponent } from './error.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [PortalFormErrorComponent],
  exports: [PortalFormErrorComponent],
})
export class FormErrorModule {}
